module.exports = __webpack_public_path__ + "static/quintoandar-c25bb45cbdf511dffb85c00dd5d1aa7a.png";